import {makeStyles} from "@material-ui/core";

const useStyles = makeStyles(() => ({
    card: {
        display: 'flex'
    }
}));
export default useStyles;
